"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { settleViewTransition } from "@/lib/view-transitions/navigate";

/** Signale à la transition en cours que la nouvelle page a été committée
 * (cf. src/lib/view-transitions/navigate.ts). Monté une fois à la racine. */
export function ViewTransitionSettler() {
  const pathname = usePathname();

  useEffect(() => {
    settleViewTransition();
  }, [pathname]);

  return null;
}
